
import { openModal } from "modules/common/store/modalsSlice";
import { useDispatch } from "react-redux";

export default function MainModal({ close, message }) {

    const dispatch = useDispatch();

    const openMainModal = async () => {
        dispatch(openModal({
            id: Date.now(),
            modalType: "ERROR_MODAL",
            modalProps: { 
                message: "ERROR went wrong"
            },
            options: { 
                closeOnOutsideClick: false
            }
        }));
    };

    return (
        <>
            <h2>Main Modal</h2>
            <p>{message}</p>
            <button onClick={openMainModal}>Trigger Error Modal</button>
            <button onClick={close}>Close</button>
        </>
    );
}
